import Joi from 'joi';
import mediaUrlSchema from '@utils/validate/blocksSchemes/mediaUrlSchema';
import videoMediaSchema from '@utils/validate/blocksSchemes/videoMediaSchema';
import thumbnailsWithBlurSchema from '@utils/validate/blocksSchemes/thumbnailsWithBlurSchema';
import imagesWithBlurSchema from '@utils/validate/blocksSchemes/imagesWithBlurSchema';
const visualWithButtonBlockSchema = Joi.object({
  type: Joi.string().valid('visualWithButtonBlock').required(),
  code: Joi.string().allow('', null).required(),
  visualStyle: Joi.string().valid('default', 'big').required(),
  header: Joi.string().allow('', null),
  headerColor: Joi.string().allow('', null),
  buttonText: Joi.string().allow('', null),
  buttonUrl: Joi.string().allow('', null),
  verticalPosition: Joi.string().valid('Start', 'start', 'center', 'end'),
  horizontalPosition: Joi.string().valid('Start', 'start', 'center', 'end'),
  voxboxButton: Joi.boolean().allow(null),
  images: mediaUrlSchema,
  imagesWithBlur: imagesWithBlurSchema,
  videos: videoMediaSchema,
  thumbnailsWithBlur: thumbnailsWithBlurSchema
}).unknown(true);
export default visualWithButtonBlockSchema;